const installApp = {
  heading: 'Cài đặt ứng dụng',
}

export default installApp
